(() => {
	angular.module('main').directive('sendQuoteModal', sendQuoteModal);

	sendQuoteModal.$inject = [];

	function sendQuoteModal() {
		return {
			scope: true,
			template: require('./sendQuote.component.html')
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/quote/sendQuote.component.js